


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { General } from '@/services/General';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { ClaimEnum } from '../../services/ClaimEnum';
import { ReportType } from '../../services/Enums';

@Component
export default class ReportWidget extends Vue {
    loadingReports: boolean = false;
    
    
    async downloadReportExcel(reportType:ReportType) {

        this.loadingReports = true;
        try {

            let endPoint = (reportType == ReportType.Products) ? "DownloadProductsReport" : "DownloadDocumentReport"

            let response = await axios({
                method: 'post',
                url: General.GetApiUrl("/api/report/" + endPoint),
                withCredentials: true,
                responseType: 'blob'
            });
            let fileName = General.getFileNameFromHeader(response.headers);
                            
            saveAs(new Blob([response.data]), fileName);
            this.loadingReports = false;
        } catch (error) {
            this.loadingReports = false;
            General.showAlertDanger(error, this);
        }
    }

    

    get isAuthorized(): boolean {
       
        return General.CheckAuthorization(ClaimEnum.CanReportDocuments);
    }
    get isAuthorizedReportDocument(): boolean {

        return General.CheckAuthorization(ClaimEnum.CanReportDocuments);
    }
    get isAuthorizedReportProducts(): boolean {
        return General.CheckAuthorization(ClaimEnum.CanReportProducts);
        
    }
    
    
}

